import { client } from "../dtos/Client";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/from";
import * as Dtos from "../dtos/Tmd.dtos";

export const groupContractApi = {
    getGroupContractByGroupId: (groupId: number): Observable<Dtos.GetGroupContractByGroupIdResponse> => {
        //Create the request.
        let request: Dtos.GetGroupContractByGroupId = new Dtos.GetGroupContractByGroupId();
        request.groupId = groupId;

        //Send request.
        const response: Promise<Dtos.GetGroupContractByGroupIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getGroupContractById: (id: number): Observable<Dtos.GetGroupContractByIdResponse> => {
        //Create the request.
        let request: Dtos.GetGroupContractById = new Dtos.GetGroupContractById();

        request.id = id;

        //Send request.
        const response: Promise<Dtos.GetGroupContractByIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    setGroupContract: (groupContract: Dtos.GroupContract): Observable<Dtos.SetGroupContractResponse> => {

        let request: Dtos.SetGroupContract = new Dtos.SetGroupContract();

        request.groupContract = groupContract;

        // send request
        const response: Promise<Dtos.SetGroupContractResponse> = client.post(request);

        return Observable.from(response);
    },
    createGroupContract: (groupId: number): Observable<Dtos.CreateGroupContractResponse> => {
        //Create the request.
        let request: Dtos.CreateGroupContract = new Dtos.CreateGroupContract();

        request.groupId = groupId;

        //Send request.
        const response: Promise<Dtos.CreateGroupContractResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    validateGroupContract: (groupContract: Dtos.GroupContract): Observable<Dtos.ValidateGroupContractResponse> => {

        let request: Dtos.ValidateGroupContract = new Dtos.ValidateGroupContract();

        request.groupContract = groupContract;

        // send request
        const response: Promise<Dtos.ValidateGroupContractResponse> = client.post(request);

        return Observable.from(response);
    },
}